/* tslint:disable */
/* eslint-disable */
/**
 * timereport-service
 * timereport-service
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CanReviewResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { IsHolidayResponse } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
// @ts-ignore
import type { SasUriDto } from '../models';
// @ts-ignore
import type { StatusCodeObjectResult } from '../models';
/**
 * PublicV1Api - axios parameter creator
 * @export
 */
export const PublicV1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [key] 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTimereportPublic: async (key?: string, comment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public/v1/review/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canReviewPublic: async (key?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public/v1/review/canReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fileExt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSasUri: async (fileExt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public/v1/storage/sas/uri`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileExt !== undefined) {
                localVarQueryParameter['fileExt'] = fileExt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isHoliday: async (date?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public/v1/swedish-calendar/is-holiday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [key] 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectTimereportPublic: async (key?: string, comment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public/v1/review/reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicV1Api - functional programming interface
 * @export
 */
export const PublicV1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicV1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [key] 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveTimereportPublic(key?: string, comment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveTimereportPublic(key, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicV1Api.approveTimereportPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canReviewPublic(key?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canReviewPublic(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicV1Api.canReviewPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [fileExt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSasUri(fileExt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SasUriDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSasUri(fileExt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicV1Api.getSasUri']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isHoliday(date?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsHolidayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isHoliday(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicV1Api.isHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [key] 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectTimereportPublic(key?: string, comment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectTimereportPublic(key, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicV1Api.rejectTimereportPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicV1Api - factory interface
 * @export
 */
export const PublicV1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicV1ApiFp(configuration)
    return {
        /**
         * 
         * @param {PublicV1ApiApproveTimereportPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTimereportPublic(requestParameters: PublicV1ApiApproveTimereportPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CanReviewResponse> {
            return localVarFp.approveTimereportPublic(requestParameters.key, requestParameters.comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicV1ApiCanReviewPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canReviewPublic(requestParameters: PublicV1ApiCanReviewPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CanReviewResponse> {
            return localVarFp.canReviewPublic(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicV1ApiGetSasUriRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSasUri(requestParameters: PublicV1ApiGetSasUriRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SasUriDto> {
            return localVarFp.getSasUri(requestParameters.fileExt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicV1ApiIsHolidayRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isHoliday(requestParameters: PublicV1ApiIsHolidayRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<IsHolidayResponse> {
            return localVarFp.isHoliday(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublicV1ApiRejectTimereportPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectTimereportPublic(requestParameters: PublicV1ApiRejectTimereportPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectTimereportPublic(requestParameters.key, requestParameters.comment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveTimereportPublic operation in PublicV1Api.
 * @export
 * @interface PublicV1ApiApproveTimereportPublicRequest
 */
export interface PublicV1ApiApproveTimereportPublicRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicV1ApiApproveTimereportPublic
     */
    readonly key?: string

    /**
     * 
     * @type {string}
     * @memberof PublicV1ApiApproveTimereportPublic
     */
    readonly comment?: string
}

/**
 * Request parameters for canReviewPublic operation in PublicV1Api.
 * @export
 * @interface PublicV1ApiCanReviewPublicRequest
 */
export interface PublicV1ApiCanReviewPublicRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicV1ApiCanReviewPublic
     */
    readonly key?: string
}

/**
 * Request parameters for getSasUri operation in PublicV1Api.
 * @export
 * @interface PublicV1ApiGetSasUriRequest
 */
export interface PublicV1ApiGetSasUriRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicV1ApiGetSasUri
     */
    readonly fileExt?: string
}

/**
 * Request parameters for isHoliday operation in PublicV1Api.
 * @export
 * @interface PublicV1ApiIsHolidayRequest
 */
export interface PublicV1ApiIsHolidayRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicV1ApiIsHoliday
     */
    readonly date?: string
}

/**
 * Request parameters for rejectTimereportPublic operation in PublicV1Api.
 * @export
 * @interface PublicV1ApiRejectTimereportPublicRequest
 */
export interface PublicV1ApiRejectTimereportPublicRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicV1ApiRejectTimereportPublic
     */
    readonly key?: string

    /**
     * 
     * @type {string}
     * @memberof PublicV1ApiRejectTimereportPublic
     */
    readonly comment?: string
}

/**
 * PublicV1Api - object-oriented interface
 * @export
 * @class PublicV1Api
 * @extends {BaseAPI}
 */
export class PublicV1Api extends BaseAPI {
    /**
     * 
     * @param {PublicV1ApiApproveTimereportPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicV1Api
     */
    public approveTimereportPublic(requestParameters: PublicV1ApiApproveTimereportPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return PublicV1ApiFp(this.configuration).approveTimereportPublic(requestParameters.key, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicV1ApiCanReviewPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicV1Api
     */
    public canReviewPublic(requestParameters: PublicV1ApiCanReviewPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return PublicV1ApiFp(this.configuration).canReviewPublic(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicV1ApiGetSasUriRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicV1Api
     */
    public getSasUri(requestParameters: PublicV1ApiGetSasUriRequest = {}, options?: RawAxiosRequestConfig) {
        return PublicV1ApiFp(this.configuration).getSasUri(requestParameters.fileExt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicV1ApiIsHolidayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicV1Api
     */
    public isHoliday(requestParameters: PublicV1ApiIsHolidayRequest = {}, options?: RawAxiosRequestConfig) {
        return PublicV1ApiFp(this.configuration).isHoliday(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublicV1ApiRejectTimereportPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicV1Api
     */
    public rejectTimereportPublic(requestParameters: PublicV1ApiRejectTimereportPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return PublicV1ApiFp(this.configuration).rejectTimereportPublic(requestParameters.key, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }
}

